module.exports = __webpack_public_path__ + "media/item03.5318a4b8.webm";